import React, { useState, useEffect} from 'react'
import { Box, Text, Divider, Button, useBreakpointValue } from "@chakra-ui/react";
import { DrawerMenu } from '../components/DrawerMenu'
import { ArrowLeftIcon, ArrowRightIcon } from '@chakra-ui/icons';

export const Layout = ({ className, children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const isIpadSize = useBreakpointValue({ base: true, md: false })

  useEffect(() => {
    if (isIpadSize !== undefined) {
      setIsCollapsed(isIpadSize)
    }
  }, [isIpadSize])

  const collapseDrawer = () => {
    setIsCollapsed((prev) => !prev)
  }

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        transition: "all .2s linear"
      }}
    >
      <Box
        sx={{
          position: "fixed",
          left: 0,
          width: isCollapsed ? "70px" : "250px",
          height: "100vh",
          borderRight: "1px solid #eee",
          transition: "all .2s linear"
        }}
      >
        <Box
          as="nav"
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            background: "#092e52"
          }}
        >
          <Box
            sx={{ 
              position: "sticky", 
              top: 0,
              display: "flex",
              justifyContent: isCollapsed ? "center" : "space-between",
              alignItems: "center",
              padding: "10px",
            }}
          >
            {!isCollapsed && <Text
              sx={{
                margin: "0",
                fontFamily: "Halant, serif",
                fontWeight: 600,
                fontSize: "20px",
                color: "#fff"
              }}
            >EdShopify</Text>}
            <Button 
              leftIcon={isCollapsed ? <ArrowRightIcon color="#fff"/> : <ArrowLeftIcon color="#fff"/>} 
              variant="ghost"
              sx={{
                padding: 0,
                ":hover": {
                  background: "none"
                }
              }}
              onClick={collapseDrawer}
            />
          </Box>
          <DrawerMenu isCollapsed={isCollapsed} />
        </Box>
      </Box>
      <Box
        as="main"
        m="0 auto"
        sx={{
          width: isCollapsed ? "calc(100% - 70px)" : "calc(100% - 250px)",
          margin: isCollapsed ? "0 0 0 70px" : "0 0 0 250px",
          minHeight: "100vh",
          transition: "all .2s linear"
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
